import { Select } from '@dynamika-shared/ui/Select/Select';
import { useEffect, useRef } from 'react';

type EditableSiteSelectProps = {
  isOpen: boolean;
  value?: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  onClose: () => void;
};

export const EditableSiteSelect = ({
  isOpen,
  value,
  options,
  onChange,
  onClose,
}: EditableSiteSelectProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') onClose();
  };

  document.addEventListener('keydown', onKeyDown);
  return () => document.removeEventListener('keydown', onKeyDown);
}, [onClose]);

  return (
    <div ref={wrapperRef}>
      <Select
        className="w-full"
        showSearch
        listHeight={220}
        autoDropdownWidth
        options={options}
        value={value}
        open={isOpen}
        onChange={onChange}
        getPopupContainer={() => wrapperRef.current!}
        filterOption={(input, option) =>
          option?.value
            ?.toString()
            .toLowerCase()
            .includes(input.toLowerCase()) ?? false
        }
        placeholder="Site ID"
        data-testid="site-id"
      />
    </div>
  );
};
